import React, { Component } from 'react';

class FormIcon extends Component {
  render() {
    return (
      <svg version="1.1" baseProfile="basic"
        x="0px" y="0px" width="32px" height="32px"
        viewBox="0 0 128 128" space="preserve">
        <path transform="matrix(0.128,0,0,0.128,0,0)" stroke="none" fill="#999999" d="M 546 601 L 380 434 L 244 675 L 755 675 L 631 498 z M 591 411 C 591 439 568 462 540 462 C 511 462 488 439 488 411 C 488 382 511 359 540 359 C 568 359 591 382 591 411 M 872 0 L 851 0 L 745 0 L 724 0 L 0 0 L 0 141 L 0 162 L 0 1000 L 1000 1000 L 1000 162 L 1000 141 L 1000 0 L 872 0 z M 893 41 L 958 41 L 958 120 L 893 120 L 893 41 z M 766 41 L 830 41 L 830 120 L 766 120 L 766 41 z M 41 41 L 703 41 L 703 120 L 41 120 L 41 41 z M 979 979 L 20 979 L 20 162 L 724 162 L 745 162 L 851 162 L 872 162 L 979 162 L 979 979 z" />
      </svg>
    );
  }
}

export default FormIcon;


// WEBPACK FOOTER //
// ./src/Components/DesignIcon.jsx